"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processShipFile = void 0;
var imports_1 = require("@lib/imports");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_1 = require("@main/common");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var voyageMessageCrewCreate_1 = require("@voyage/multi/voyageMessageCrewCreate");
var voyageMessageCrewCreate_sidecar_1 = require("@voyage/multi/voyageMessageCrewCreate-sidecar");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageGameStatus_enemyShips_sidecar_1 = require("@voyage/game-status/voyageGameStatus_enemyShips-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageFakeInfo_sidecar_1 = require("@voyage/text/voyageFakeInfo-sidecar");
var voyageTileData_1 = require("@voyage/tilemap/voyageTileData");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
var namespace = 'voyage-game-process-ship-file';
function processShipFile(doCreateStuff) {
    var elevatorId = 0;
    var isHost = voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost();
    console.log(namespace, 'start', doCreateStuff);
    // Reset tilemap systems
    // voyageTilemap.resetSystems()
    imports_1.l.forEach(voyageTilemap_sidecar_1.voyageTilemap.get().parts, function (c) {
        var hide = false;
        var killText = false;
        if (c.tile3.type === voyageTileData_1.EVoyageTile.CrewSpawn) {
            hide = true;
            if (doCreateStuff) {
                if (isHost) {
                    voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
                        crewId: common_1.createId(),
                        i: c.i,
                        j: c.j,
                        team: 0,
                        type: diveCrew_1.EVoyageCrewType.Hero,
                        heroType: diveCrew_hero_data_1.EDiveHeroSubtype.None,
                        enemyType: '',
                        method: voyageMessageCrewCreate_1.EVoyageCrewCreateMethod.Normal,
                        name: voyageFakeInfo_sidecar_1.voyageFakeInfo.genFakeName_nonDeterministic(),
                        energy: rando_sidecar_1.rando.i(100, diveCrew_sidecar_1.diveCrew.maxEnergy),
                        hitpoints: 100,
                    });
                }
            }
        }
        if (c.tile3.type === voyageTileData_1.EVoyageTile.Text) {
            hide = true;
        }
        var sys = null;
        if (c.tile3.type === voyageTileData_1.EVoyageTile.Elevator) {
            voyageTilemap_sidecar_1.voyageTilemap.addGameElevator(c);
            elevatorId++;
            sys = voyageTilemap_sidecar_1.voyageTilemap.addGameSystem2(c, 'elevator-' + elevatorId);
        }
        if (c.tile3.type === voyageTileData_1.EVoyageTile.System) {
            sys = voyageTilemap_sidecar_1.voyageTilemap.addGameSystem(c);
        }
        if (c.tile3.type === voyageTileData_1.EVoyageTile.MedPad) {
            sys = voyageTilemap_sidecar_1.voyageTilemap.addGameSystem(c);
        }
        // Post-process some systems
        if (sys) {
            if (sys.killText) {
                killText = true;
            }
            if (sys.hide) {
                hide = true;
            }
        }
        if (c.tile3.type === voyageTileData_1.EVoyageTile.Test) {
            hide = true;
            // Disable camera for now
            // if (c.text3 === 'camera') {
            //   hide = true
            //   killText = true
            //   voyageCamera.centerOn(c.x, c.y)
            // }
            if (!isHost || !doCreateStuff) {
                hide = true;
                killText = true;
            }
            if (isHost && doCreateStuff) {
                if (c.text3 === 'fire') {
                    hide = true;
                    killText = true;
                    var cr = diveCrew_sidecar_1.diveCrew.create(diveCrew_1.EVoyageCrewType.Fire, diveCrew_hero_data_1.EDiveHeroSubtype.None, '', -1);
                    diveCrew_sidecar_1.diveCrew.moveToIIJ(cr, c);
                }
                if (c.text3 === 'indie') {
                    hide = true;
                    killText = true;
                    voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
                        crewId: common_1.createId(),
                        i: c.i,
                        j: c.j,
                        team: 0,
                        type: diveCrew_1.EVoyageCrewType.Pet,
                        heroType: diveCrew_hero_data_1.EDiveHeroSubtype.None,
                        enemyType: '',
                        method: voyageMessageCrewCreate_1.EVoyageCrewCreateMethod.Normal,
                        name: 'Indie',
                        energy: rando_sidecar_1.rando.i(100, diveCrew_sidecar_1.diveCrew.maxEnergy),
                        hitpoints: 100,
                    });
                }
                if (c.text3 === 'alien') {
                    hide = true;
                    killText = true;
                    var cr = diveCrew_sidecar_1.diveCrew.create(diveCrew_1.EVoyageCrewType.Enemy, diveCrew_hero_data_1.EDiveHeroSubtype.None, '', 1);
                    diveCrew_sidecar_1.diveCrew.moveToIIJ(cr, c);
                }
                if (c.text3 === 'breach') {
                    hide = true;
                    killText = true;
                    var cr = diveCrew_sidecar_1.diveCrew.create(diveCrew_1.EVoyageCrewType.HullBreach, diveCrew_hero_data_1.EDiveHeroSubtype.None, '', -1);
                    diveCrew_sidecar_1.diveCrew.moveToIIJ(cr, c);
                }
                if (c.text3 === 'dead') {
                    hide = true;
                    killText = true;
                    if (rando_sidecar_1.rando.chance(0.5)) {
                        var cr = diveCrew_sidecar_1.diveCrew.create(diveCrew_1.EVoyageCrewType.Hero, diveCrew_hero_data_1.EDiveHeroSubtype.None, '', 0);
                        diveCrew_sidecar_1.diveCrew.moveToIIJ(cr, c);
                        diveCrew_sidecar_1.diveCrew.hurt(cr, 100, voyageMessageCrewHurt_1.EVoyageCrewDamageType.FoundLikeThat, 0); //  'Found dead')
                    }
                    else {
                        var cr = diveCrew_sidecar_1.diveCrew.create(diveCrew_1.EVoyageCrewType.Enemy, diveCrew_hero_data_1.EDiveHeroSubtype.None, '', 0);
                        diveCrew_sidecar_1.diveCrew.moveToIIJ(cr, c);
                        diveCrew_sidecar_1.diveCrew.hurt(cr, 100, voyageMessageCrewHurt_1.EVoyageCrewDamageType.FoundLikeThat, 0); //, 'Found dead')
                    }
                }
                if (c.text3 === 'es-hammerhead') {
                    hide = true;
                    killText = true;
                    voyageGameStatus_enemyShips_sidecar_1.voyageGameStatus_enemyShips.createHammerheadClass();
                }
            }
        }
        if (c.image3 && hide) {
            c.image3.visible = false;
        }
        if (c.text && killText) {
            stevieTexts2_sidecar_1.stevieTexts2.kill(c.text);
            c.text = null;
        }
    });
}
exports.processShipFile = processShipFile;
